var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12504 6.65419L6.71579 11.1712C6.48647 11.5636 6.32767 12.0034 6.25692 12.4738L6.12101 13.3775C5.59335 16.8865 5.64268 20.4581 6.26705 23.9511C6.52045 25.3687 7.68463 26.4455 9.11767 26.5877L10.7583 26.7506C14.6874 27.1406 18.6455 27.1406 22.5746 26.7506L24.2153 26.5877C25.6482 26.4455 26.8125 25.3687 27.0658 23.9511C27.6902 20.4581 27.7395 16.8865 27.2118 13.3775L27.0759 12.4738C27.0023 11.984 26.8333 11.5275 26.5885 11.123L25.2066 6.65968C24.8485 5.50292 23.8538 4.65756 22.6545 4.49067C18.6815 3.9378 14.6493 3.93811 10.6765 4.49096C9.47944 4.65754 8.48515 5.49996 8.12504 6.65419ZM22.3787 6.47158C18.5889 5.94418 14.7421 5.94446 10.9521 6.47187C10.5213 6.53183 10.1637 6.83511 10.0343 7.24986L9.36611 9.39148C9.41625 9.3844 9.46673 9.37834 9.51752 9.3733L10.8218 9.24384C14.7086 8.85806 18.6242 8.85806 22.5111 9.24384L23.8154 9.3733C23.8633 9.37806 23.911 9.38374 23.9583 9.39031L23.2961 7.25118C23.1674 6.8354 22.8099 6.53156 22.3787 6.47158ZM21.9998 15.667C22.5521 15.667 22.9998 15.2193 22.9998 14.667C22.9998 14.1147 22.5521 13.667 21.9998 13.667H11.3331C10.7809 13.667 10.3331 14.1147 10.3331 14.667C10.3331 15.2193 10.7809 15.667 11.3331 15.667H21.9998Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.004717bff7f57f19468698ee16761345.svg";
export { ForwardRef as ReactComponent };